import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Default Cell
const DefaultCell = props => (
  <div
    className={classnames('rt-td--default', props.className, {
      [props.valueClassName]: props.value,
    })}
  >
    <span>{props.value}</span>
  </div>
);

DefaultCell.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueClassName: PropTypes.string,
};

const defaultValue = props => props.value;
export const makeDefaultCell = (newProps, makeValue = defaultValue) => props => (
  <DefaultCell {...props} {...newProps} value={makeValue(props)} />
);

export const makeCountCell = newProps =>
  makeDefaultCell(newProps, props => (props.value > 0 ? props.value : null));

export default DefaultCell;
